// React Imports
import React, { Component, useEffect, useState } from "react"
import * as APITypes from "constants/API";
import axios from "axios";

import OptimizationStore from "../../../modules/optimization/store/OptimizationStore";
import "./compare-product-modal.css"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { toJS } from "mobx";
import AuthStore from "modules/login/store/AuthStore";
import { COMPARE_PRODUCTS } from "constants/UserClicksConstant";
import { Image } from "react-bootstrap";
import { CloseIconBlack } from "constants/Images";

const CompareProductModal = (props) => {

    const { form, data } = props
    const [showTooTip, setToolTip] = useState(false)
    const history = useHistory();

    useEffect(() => {
        let value = OptimizationStore.showCompareProductToolTip === "true" ? true : false
        setToolTip(value)
    }, [OptimizationStore.showCompareProductToolTip])

    const redirect = (form, data) => {
        //! for save user clicks
        AuthStore.saveUserClicks(COMPARE_PRODUCTS)
        let info = {
            family_product_id: data.data.family_product_id,
            risk: data.data.selectedRisk,
            target_amount: 0,
            recommended_cover: data.data.recommended_sum_assured,
            current_product_id: data.data.product_id,
            current_package_id: data.data.package_id
        };
        localStorage.setItem("recommendedProduct", JSON.stringify(info));
        // OptimizationStore.setRecommendedProductData(data)
        productBenefitMapping()
        history.push({ pathname: "/compare-product", state: data.productName })
    }

    const productBenefitMapping = async () => {
        let response = await axios.get(APITypes.PRODUCT_BENEFIt_MAPPING)
        if (response.status === "success") {
            OptimizationStore.setproductBanefitData(response.data)
        }
    }

    return (
        <>
            <div className="campareProductModalDiv d-flex align-items-center pl-0 pl-md-2">
                <div
                    className=" btn text-primary p-0 LA-btn font-size-14 font-size-md-13 font-weight-light"
                    onClick={() => redirect(form, data)}
                >
                    [ Compare Product ]
                </div>
                {showTooTip &&
                    <>
                        <div class="tooltip-compare-product row">
                            <div className="col-10  px-0 tooltip-text">
                                Ensure {data.productName} meets your needs. Compare and decide
                            </div>
                            <div className="col-2 px-0">
                                <Image
                                    className="close-icon-compare-product"
                                    src={CloseIconBlack}
                                    onClick={() => { setToolTip(false) }}
                                />
                            </div>

                        </div>
                    </>
                }
            </div>
        </>
    )
}
export default CompareProductModal;